import { memo } from 'react';
import { areEqual } from 'react-window';
import { Draggable } from 'react-beautiful-dnd';

import { DataAttribute } from '../DataAttribute';

import { DataAttributeRowProps } from './DataAttributeRow.props';
import { DataAttributeRowItem } from './DataAttributeRow.types';

/**
 DataAttributeRow component
 @returns {JSX.Element}
 */

export const DataAttributeRow = memo(({ data, index, style }: DataAttributeRowProps) => {
  const item = data[index];
  const draggableId = JSON.stringify({
    id: item.id,
    label: item.label,
    type: item.type,
    signalType: item.signalType,
  } as DataAttributeRowItem);

  return (
    <Draggable draggableId={draggableId} index={index} key={item.id}>
      {(provided) => <DataAttribute provided={provided} item={item} style={style} />}
    </Draggable>
  );
}, areEqual);

DataAttributeRow.displayName = 'DataAttributeRow';
